import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["form"]
  static values = {documentUrl: String}

  connect() {
    this.#generateDocumentIframe(this.element);
    this.#injectCsrfToken();
  }

  #generateDocumentIframe(container) {
    const iframe = document.createElement('iframe');
    iframe.classList = ['w-full h-lvh'];
    iframe.src = this.documentUrlValue;

    container.prepend(iframe);
  }

  #injectCsrfToken() {
    // Inject CSRF token manually, because form can be rendered with Turbo from Sidekiq
    // Token is missing in this context
    const formToken = this.formTarget.querySelector('input[name="authenticity_token"]');
    if (formToken) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "authenticity_token";
    input.value = csrfToken;
    this.formTarget.prepend(input);
  }
}
